import { render } from "./FbFieldSettings.vue?vue&type=template&id=20f77ea6"
import script from "./FbFieldSettings.vue?vue&type=script&lang=js"
export * from "./FbFieldSettings.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\FormBuilder\\vue_project\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__